import { Loader2 } from "lucide-react";
import styles from "../styles/applicationDetail.module.css";
import type { TabType } from "../types/pages";
import type { ApplicationDetailEditActionsProps } from "../types";

const EDITABLE_TABS: TabType[] = [
  "aboutyourselfinfo",
  "propertyinfo",
  "employmentinfo",
];

export function ApplicationDetailEditActions({
  isEdit,
  selectedTab,
  updateButtonRef,
  isSaving = false,
  onSave,
  onCancel,
}: ApplicationDetailEditActionsProps) {
  if (!isEdit || !EDITABLE_TABS.includes(selectedTab)) {
    return null;
  }

  return (
    <div className={styles.editActions} data-testid="application-detail-edit-actions">
      <button
        type="button"
        ref={updateButtonRef}
        className={`${styles.btn} ${styles.btnPrimary}`}
        data-testid="application-detail-update-button"
        disabled={isSaving}
        aria-busy={isSaving}
        onClick={() => void onSave()}
      >
        {isSaving ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
            Updating…
          </>
        ) : (
          "Update"
        )}
      </button>
      <button
        type="button"
        className={`${styles.btn} ${styles.btnSecondary}`}
        data-testid="application-detail-cancel-button"
        disabled={isSaving}
        onClick={onCancel}
      >
        Cancel
      </button>
    </div>
  );
}
